// extracted by mini-css-extract-plugin
module.exports = {"root":"CommSwitch_root__3-8a2"};